<template>
    <div>
        <h1>Our Team</h1>
    </div>
</template>